import { useContext } from "react";
import { CompanyOverviewContext } from "./context";

export const useCompanyOverviewContext = () => {
    const context = useContext(CompanyOverviewContext);

    if (context) {
        return context;
    }

    throw new Error(`useOrganizationOverview must be used within the context`);
};
